export const FETCH_ORG_PREFERENCES_LOADING = "FETCH_ORG_PREFERENCES_LOADING";
export const FETCH_ORG_PREFERENCES_SUCCESS = "FETCH_ORG_PREFERENCES_SUCCESS";
export const FETCH_ORG_PREFERENCES_FAILED = "FETCH_ORG_PREFERENCES_FAILED";
